// @flow

import React, { Component } from "react";
import { scaleLinear } from "d3-scale";
import { Motion, spring } from "react-motion";

const noop = () => {};

type DefaultProps = {
  min: number,
  max: number,
  onComplete: () => void
};

type Props = {
  value: number,
  guessedValue: number,
  onComplete: () => void,
  unit: string,
  color: string,
  min: number,
  max: number,
  // Translation
  t: (s: string) => string
};

type State = {
  config: { stiffness?: number, damping?: number, precision?: number }
};

export default class AnswerSlider
  extends Component<DefaultProps, Props, State> {
  scale: any;

  static defaultProps = {
    min: 0,
    max: 100,
    onComplete: noop
  };

  state = {
    config: { stiffness: 100, damping: 30, precision: 1 }
  };

  componentWillMount() {
    const { min, max } = this.props;
    this.scale = scaleLinear().domain([min, max]).range([0, 100]);
  }

  componentWillReceiveProps(nextProps: Props) {
    const { min, max } = nextProps;
    this.scale.domain([min, max]);
  }

  render() {
    const { value, guessedValue, unit, color, onComplete } = this.props;
    const { config } = this.state;
    const { scale } = this;

    return (
      <div className="Slider">

        <Motion
          defaultStyle={{ val: guessedValue }}
          style={{ val: spring(value, config) }}
          onRest={onComplete}
        >
          {({ val }) => {
            const x = `${scale(val)}%`;
            return (
              <div>
                <div
                  className="Slider-Bar"
                  style={{ width: x, backgroundColor: color }}
                />
                <div className="Slider-Indicator" style={{ left: x }} />
                <div className="Slider-Label" style={{ top: 32, left: x }}>
                  {Math.round(val)} {unit}
                  <div className="Slider-SubLabel">
                    Correct Answer
                  </div>
                </div>
              </div>
            );
          }}
        </Motion>
        <div
          className="Slider-Indicator"
          style={{ left: `${scale(guessedValue)}%`, opacity: 0.5 }}
        />
        <div
          className="Slider-Label"
          style={{ bottom: 32, left: `${scale(guessedValue)}%`, opacity: 0.5 }}
        >
          <div className="Slider-SubLabel">Your guess</div>
          {guessedValue} {unit}
        </div>

        <style jsx>{`
          .Slider {
            background: #fff;
            width: calc(100% - 40px);
            max-width: 420px;
            height: 24px;
            position: relative;
            margin: 50px auto;
            touch-action: manipulation;
          }

          .Slider-Bar {
            transition: opacity 0.2s;
            position: absolute;
            top: 0;
            left: 0;
            height: 24px;
            background: #333;
          }

          .Slider-TickLabel {
            color: #444;
            font-family: FrutigerLTCom;
            font-size: 12px;
            position: absolute;
            top: 28px;
          }

          .Slider-Handle {
            box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            width: 22px;
            margin-left: -11px;
            margin-top: -4px;
            height: 32px;
            background: #000;
          }

          .Slider-Label {
            transform: translateX(-50%);
            font-family: FrutigerLTCom;
            font-weight: 700;
            position: absolute;
            left: 0;
            text-align: center;
            white-space: nowrap;
          }

          .Slider-SubLabel {
            font-size: 12px;
            font-weight: 500;
          }

          .Slider-Indicator {
            position: absolute;
            top: 0;
            left: 0;
            width: 2px;
            margin-left: -1px;
            height: 24px;
            background: #000;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/AnswerSlider.js